<template>
  <div class="container page setbank-page">
    <van-nav-bar :title="$t('setting.bank_info')" class="nav-bar">
      <template #left>
        <button class="nav-back" type="button" aria-label="Back" @click="back()">
          <van-icon name="arrow-left" />
        </button>
      </template>
    </van-nav-bar>
    <div class="wrapper">
      <div class="section-heading">
        <div class="section-kicker">Secure withdrawal</div>
        <h1>Withdrawal channels</h1>
        <p>Choose a channel to bind an account or review its saved details.</p>
      </div>
      <!-- 渠道选择列表 -->
      <div class="channel-list">
        <button class="channel-item" type="button" :class="{'is-bound': channelData.erc20 && channelData.erc20 !== ''}" aria-label="ERC20 withdrawal channel" @click="selectChannel('erc20')">
          <span class="channel-icon"><van-icon name="exchange" /></span>
          <span class="channel-info">
            <span class="channel-name">ERC20</span>
            <span class="channel-status" v-if="channelData.erc20 && channelData.erc20 !== ''"><van-icon name="passed" /> Binded</span>
            <span class="channel-status unbind" v-else>Not Bind</span>
          </span>
          <van-icon class="channel-arrow" name="arrow" />
        </button>
        
        <button class="channel-item" type="button" :class="{'is-bound': channelData.cashapp && channelData.cashapp !== ''}" aria-label="Cash App withdrawal channel" @click="selectChannel('cashapp')">
          <span class="channel-icon"><van-icon name="balance-o" /></span>
          <span class="channel-info">
            <span class="channel-name">Cash App</span>
            <span class="channel-status" v-if="channelData.cashapp && channelData.cashapp !== ''"><van-icon name="passed" /> Binded</span>
            <span class="channel-status unbind" v-else>Not Bind</span>
          </span>
          <van-icon class="channel-arrow" name="arrow" />
        </button>
        
        <button class="channel-item" type="button" :class="{'is-bound': channelData.paypal && channelData.paypal !== ''}" aria-label="PayPal withdrawal channel" @click="selectChannel('paypal')">
          <span class="channel-icon"><van-icon name="card" /></span>
          <span class="channel-info">
            <span class="channel-name">PayPal</span>
            <span class="channel-status" v-if="channelData.paypal && channelData.paypal !== ''"><van-icon name="passed" /> Binded</span>
            <span class="channel-status unbind" v-else>Not Bind</span>
          </span>
          <van-icon class="channel-arrow" name="arrow" />
        </button>
      </div>
      
      <div class="tips"><van-icon name="shield-o" /> Please bind withdrawal channel for future withdrawal operations</div>
    </div>
    
    <!-- 详情弹窗 -->
    <van-popup v-model="showDetailPopup" position="bottom" :style="{ height: 'auto' }" class="detail-popup">
      <div class="popup-header">
        <div class="popup-title">Channel Details</div>
        <button class="popup-close" type="button" aria-label="Close channel details" @click="showDetailPopup = false">
          <van-icon name="cross" />
        </button>
      </div>
      <div class="popup-content">
        <div class="detail-item">
          <div class="detail-label">Channel Type:</div>
          <div class="detail-value">{{channelDetail.channel_type_name}}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label">Account:</div>
          <div class="detail-value">{{channelDetail.account}}</div>
        </div>
        <div class="detail-item" v-if="channelDetail.holder_name">
          <div class="detail-label">Holder Name:</div>
          <div class="detail-value">{{channelDetail.holder_name}}</div>
        </div>
        <div class="detail-item" v-if="channelDetail.mobile">
          <div class="detail-label">Mobile:</div>
          <div class="detail-value">{{channelDetail.mobile}}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label">Bind Time:</div>
          <div class="detail-value">{{channelDetail.bind_time}}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      channelData: {
        erc20: '',
        cashapp: '',
        paypal: ''
      },
      userInfo:{},
      from:'',
      showDetailPopup: false,
      channelDetail: {}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    getUserChannelInfo(){
      this.$http({
        method: 'get',
        url: 'getWithdrawalChannels'
      }).then(res=>{
        if(res.code === 200){
          this.channelData = {
            erc20: res.data.erc20 || '',
            cashapp: res.data.cashapp || '',
            paypal: res.data.paypal || ''
          };
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    selectChannel(channel) {
      // if(!this.userInfo.paypassword){
      //   this.$router.push("SetPayPassword?from=Setbank"+(this.from!=''?(":"+this.from):""));
      //   this.$toast(this.$t("setting.set_pwd_first"));
      //   return;
      // }
      
      // 检查是否已绑定
      if(this.channelData[channel] && this.channelData[channel] !== '') {
        // 已绑定，显示详情
        this.showChannelDetail(channel);
      } else {
        // 未绑定，跳转绑定页面
        if(channel === 'erc20') {
          this.$router.push('/BindERC20');
        } else if(channel === 'cashapp') {
          this.$router.push('/BindCashApp');
        } else if(channel === 'paypal') {
          this.$router.push('/BindPayPal');
        }
      }
    },
    showChannelDetail(channel) {
      const detail = this.channelData[channel];
      
      // 设置渠道类型名称和账户信息
      if(channel === 'erc20') {
        this.channelDetail = {
          channel_type_name: 'ERC20',
          account: detail.wallet_address,
          holder_name: detail.holder_name,
          mobile: detail.mobile || '',
          bind_time: detail.bind_time
        };
      } else if(channel === 'cashapp') {
        this.channelDetail = {
          channel_type_name: 'Cash App',
          account: detail.cashtag,
          holder_name: detail.holder_name,
          mobile: detail.mobile || '',
          bind_time: detail.bind_time
        };
      } else if(channel === 'paypal') {
        this.channelDetail = {
          channel_type_name: 'PayPal',
          account: detail.paypal_email,
          holder_name: detail.holder_name,
          mobile: detail.mobile || '',
          bind_time: detail.bind_time
        };
      }
      
      this.showDetailPopup = true;
    }
  },
  created() {
    this.from = this.$route.query.from;
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserChannelInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.wrapper {
  padding: 0.2rem;
}
.channel-list {
  background: #fff;
  border-radius: 0.1rem;
}
.channel-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.3rem 0.2rem;
  border-bottom: 0.01rem solid #f0f0f0;
  cursor: pointer;
}
.channel-item:last-child {
  border-bottom: none;
}
.channel-info {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.channel-name {
  font-size: 0.32rem;
  color: #323233;
  font-weight: 500;
}
.channel-status {
  font-size: 0.28rem;
  color: #07c160;
}
.channel-status.unbind {
  color: #969799;
}
.wrapper .tips {
  margin: 0.3rem 0;
  font-size: 0.26rem;
  color: #969799;
  line-height: 0.4rem;
}
.bind-popup {
  border-radius: 0.2rem 0.2rem 0 0;
}
.popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.3rem 0.2rem;
  border-bottom: 0.01rem solid #f0f0f0;
}
.popup-title {
  font-size: 0.34rem;
  font-weight: 500;
  color: #323233;
}
.popup-content {
  padding: 0.3rem 0.2rem;
}
.bind-input {
  margin-bottom: 0.4rem;
}
.bind-btn {
  height: 0.88rem;
  font-size: 0.32rem;
  border-radius: 0.44rem;
  background: linear-gradient(270deg, #5b60df, #5b60df);
}
.detail-popup {
  border-radius: 0.2rem 0.2rem 0 0;
}
.detail-popup .popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.3rem 0.32rem;
  border-bottom: 0.01rem solid #f0f0f0;
}
.detail-popup .popup-title {
  font-size: 0.34rem;
  font-weight: 500;
  color: #323233;
}
.detail-popup .popup-content {
  padding: 0.3rem 0.32rem;
}
.detail-item {
  display: flex;
  justify-content: space-between;
  padding: 0.24rem 0;
  border-bottom: 0.01rem solid #f7f8fa;
}
.detail-item:last-child {
  border-bottom: none;
}
.detail-label {
  font-size: 0.28rem;
  color: #646566;
}
.detail-value {
  font-size: 0.28rem;
  color: #323233;
  font-weight: 500;
  max-width: 60%;
  text-align: right;
  word-break: break-all;
}

/* Victoria Dating Club UI2 */
.setbank-page {
  color: var(--victoria-text);
  background: transparent;
}

.setbank-page .nav-back {
  display: inline-flex;
  width: 0.88rem;
  height: 0.88rem;
  margin-left: -0.2rem;
  align-items: center;
  justify-content: center;
  color: var(--victoria-text);
  background: transparent;
  border: 0;
  border-radius: 50%;
}

.setbank-page .wrapper {
  width: 100%;
  padding: 0.42rem 0.28rem max(0.52rem, env(safe-area-inset-bottom));
}

.setbank-page .section-heading {
  margin-bottom: 0.36rem;
  padding: 0.18rem 0.16rem;
}

.setbank-page .section-kicker {
  margin-bottom: 0.08rem;
  color: var(--victoria-primary);
  font-size: 0.26rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.setbank-page .section-heading h1 {
  margin: 0;
  color: var(--victoria-text);
  font-family: var(--victoria-font-ui);
  font-size: 0.58rem;
  line-height: 1.25;
}

.setbank-page .section-heading p {
  margin: 0.18rem 0 0;
  color: var(--victoria-text-muted);
  font-size: 0.3rem;
  line-height: 1.6;
}

.setbank-page .channel-list {
  display: grid;
  gap: 0.22rem;
  background: transparent;
  border-radius: 0;
}

.setbank-page .channel-item {
  display: grid;
  width: 100%;
  min-height: 1.62rem;
  padding: 0.28rem 0.3rem;
  grid-template-columns: 0.92rem minmax(0, 1fr) auto;
  gap: 0.24rem;
  align-items: center;
  color: var(--victoria-text);
  text-align: left;
  background: var(--victoria-surface);
  border: 1px solid var(--victoria-divider);
  border-radius: 0.4rem;
  box-shadow: 0 0.2rem 0.58rem rgba(0, 0, 0, 0.26);
  backdrop-filter: blur(12px);
}

.setbank-page .channel-item.is-bound {
  background: linear-gradient(145deg, rgba(76, 50, 62, 0.92), rgba(25, 20, 24, 0.92));
  border-color: rgba(231, 160, 174, 0.4);
  box-shadow: 0 0.2rem 0.62rem rgba(207, 127, 145, 0.16);
}

.setbank-page .channel-icon {
  display: inline-flex;
  width: 0.92rem;
  height: 0.92rem;
  align-items: center;
  justify-content: center;
  color: var(--victoria-primary);
  font-size: 0.46rem;
  background: rgba(168, 107, 121, 0.16);
  border: 1px solid rgba(231, 160, 174, 0.22);
  border-radius: 0.28rem;
}

.setbank-page .channel-info {
  display: flex;
  min-width: 0;
  gap: 0.1rem;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
}

.setbank-page .channel-name {
  color: var(--victoria-text) !important;
  font-family: var(--victoria-font-ui);
  font-size: 0.38rem;
  font-weight: 600;
  line-height: 1.35;
}

.setbank-page .channel-status {
  display: inline-flex;
  gap: 0.08rem;
  align-items: center;
  color: var(--victoria-light-rose);
  font-size: 0.26rem;
  line-height: 1.4;
}

.setbank-page .channel-status.unbind {
  color: var(--victoria-text-muted);
}

.setbank-page .channel-arrow {
  color: var(--victoria-muted-rose);
  font-size: 0.42rem;
}

.setbank-page .channel-item:focus-visible,
.setbank-page .nav-back:focus-visible,
.setbank-page .popup-close:focus-visible {
  outline: 2px solid var(--victoria-light-rose);
  outline-offset: 2px;
}

.setbank-page .tips {
  display: flex;
  margin: 0.32rem 0.1rem 0;
  gap: 0.12rem;
  align-items: flex-start;
  color: var(--victoria-text-muted);
  font-size: 0.27rem;
  line-height: 1.55;
}

.setbank-page .tips .van-icon {
  flex: 0 0 auto;
  margin-top: 0.04rem;
  color: var(--victoria-primary);
  font-size: 0.38rem;
}

.setbank-page ::v-deep .detail-popup {
  overflow: hidden;
  color: var(--victoria-text);
  background: linear-gradient(180deg, #2d242a, #151216);
  border-top: 1px solid var(--victoria-border);
  border-radius: 0.5rem 0.5rem 0 0;
  box-shadow: 0 -0.24rem 0.9rem rgba(0, 0, 0, 0.42);
}

.setbank-page .detail-popup .popup-header {
  min-height: 1.28rem;
  padding: 0.28rem 0.36rem;
  border-bottom-color: var(--victoria-divider);
}

.setbank-page .detail-popup .popup-title {
  color: var(--victoria-text);
  font-family: var(--victoria-font-ui);
  font-size: 0.42rem;
}

.setbank-page .popup-close {
  display: inline-flex;
  width: 0.82rem;
  height: 0.82rem;
  align-items: center;
  justify-content: center;
  color: var(--victoria-light-rose);
  font-size: 0.42rem;
  background: rgba(168, 107, 121, 0.14);
  border: 1px solid var(--victoria-divider);
  border-radius: 50%;
}

.setbank-page .detail-popup .popup-content {
  padding: 0.18rem 0.36rem max(0.42rem, env(safe-area-inset-bottom));
}

.setbank-page .detail-popup .detail-item {
  min-height: 1.08rem;
  padding: 0.28rem 0;
  gap: 0.3rem;
  align-items: center;
  border-bottom-color: var(--victoria-divider);
}

.setbank-page .detail-popup .detail-label {
  color: var(--victoria-text-muted);
  font-size: 0.28rem;
}

.setbank-page .detail-popup .detail-value {
  color: var(--victoria-text);
  font-size: 0.3rem;
}
</style>
